var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-gauge',{attrs:{"refid":_vm.nameid,"options":{
      hasNeedle: true,
      outerNeedle: true,
      needleStartValue: 0,
      needleColor: 'red',
      arcColors: ['#66BB6A', '#E0E0E0'],
      needleValue: 10,
      arcDelimiters: [10, 36, 78],
      centralLabel: 'meterWat',
      rangeLabel: ['0', '50'],
      needleUpdateSpeed: 1,
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }